<div class="display-flex">
  <div class="col-md-6">
    <h4 mat-dialog-title style="font-weight: bold;">Network Logs</h4>
  </div>
  <div class="col-md-6 text-right p-4">
    <a href="javascript:" mat-dialog-close><i class="fa fa-times-circle text-secondary"></i></a>
  </div>
</div>
<mat-dialog-content class="mat-typography">
  <div class="row">
    <div class="table-responsive" *ngIf="fileSource">
      <table class="table">
        <thead>
          <tr>
            <th>#</th>
            <th>URL</th>
            <th>Status</th>
            <th>Type</th>
            <th>Method</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of fileSource | paginate: { itemsPerPage: 10, currentPage: pageNo } let i= index">
            <td>{{i+1+10*(pageNo-1)}}</td>
            <td style="max-width: 230px;word-wrap: break-word;white-space: pre-wrap;">
              <span *ngIf="!item.showMore"> {{item.url ? trimString(item.url,50) :
                ''}}</span>
              <span *ngIf="item.showMore"> {{item.url}} </span>
              <span *ngIf="item.url && item.url.length> 50" (click)="item.showMore = !item.showMore">
                <a href="javascript:" class="ml-2">{{item.showMore ? 'less' : 'More'}}</a>
              </span>
            </td>
            <td>{{ item.status }}</td>
            <td>{{ item.type }}</td>
            <td>{{ item.method }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="col-md-12 text-center" *ngIf="!fileSource">
      <p>No record.</p>
    </div>
    <div class="col-md-12 text-center">
      <pagination-controls (pageChange)="pageNo = $event"></pagination-controls>
    </div>
  </div>
</mat-dialog-content>